import { Box, List, ListItem, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";



function DevelopmentPractices() {
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [])

    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Typography
                component="h1"
                variant="h1"
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0
                }}
            >
                Secure Development Practices
            </Typography>
            <Typography data-aos="fade-up" gutterBottom mt={{ xs: 2, md: 3, lg: 5 }} className='fs-52 text-color-main' fontWeight={500}>Secure Development Practices</Typography>

            <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey mt-3 mb-5'>
                App Gallery follows industry-standard secure development and delivery practices. While we do not currently hold formal certifications such as ISO 27001, we implement a security-first approach across our software development lifecycle aligned with widely accepted frameworks such as OWASP Foundation.            </Typography>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    1. Secure Software Development Lifecycle (SSDLC)
                </Typography>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    We integrate security practices throughout all phases of development, including:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Security considerations during requirements and design stages
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Secure architecture principles (e.g., least privilege, defense-in-depth)
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Ongoing risk assessment and threat identification
                        </Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    Security is embedded into each phase of the SDLC rather than treated as a separate activity
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    2.  Secure Coding Practices
                </Typography>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    Our development team follows secure coding standards aligned with OWASP guidance, including:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Input validation and output sanitisation
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Secure authentication and access control implementation
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Protection against common vulnerabilities (e.g., injection, XSS)
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Secure error handling and logging
                        </Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    These practices are designed to reduce common application-layer vulnerabilities
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    3. Code Review & Quality Assurance
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Peer code reviews for all production changes
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Security-focused review checkpoints for sensitive functionality
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Use of standard frameworks and libraries to minimise risk
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    4. Security Testing
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    Where applicable, we incorporate:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Static and/or dynamic application security testing (SAST/DAST)</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Functional and regression testing prior to release</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Client-led or third-party penetration testing support</Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    Security testing is part of verification before deployment
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    5. Dependency & Vulnerability Management
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Monitoring and updating third-party libraries</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Avoiding use of deprecated or vulnerable components</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Applying patches and updates as part of release cycles</Typography></ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    6. Access Control & Data Handling
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Role-based access controls (RBAC)
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Least-privilege access to systems and environments
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Restricted access to client data on a need-to-know basis
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    7. DevOps & Secure Deployment Practices
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Controlled deployment processes
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Environment segregation (development, staging, production)
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Secure handling of credentials and secrets
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    8. Hosting & Infrastructure Responsibility
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            App Gallery does not manage hosting or infrastructure.
                        </Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    All infrastructure security, network controls, and uptime responsibilities remain with the client or their cloud provider.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    9. Security Governance
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Internal best-practice guidelines for secure development
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Security awareness as part of engineering practices
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Alignment with industry frameworks (OWASP Top 10, secure-by-design principles)
                        </Typography>
                    </ListItem>
                </List>
            </Box>
            <Typography data-aos="fade-up" className='fs-16 text-grey'>
                App Gallery is committed to continuously improving its security practices and can align with client-specific security requirements, audits, or compliance frameworks where required.            </Typography>

        </Box>
    )
}

export default DevelopmentPractices
